import { render } from "./OttoFooter.vue?vue&type=template&id=4441609b&scoped=true&ts=true"
import script from "./OttoFooter.vue?vue&type=script&lang=ts"
export * from "./OttoFooter.vue?vue&type=script&lang=ts"

import "./OttoFooter.vue?vue&type=style&index=0&id=4441609b&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4441609b"]])

export default __exports__